import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Autocomplete, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import { MoneyMaskedInput } from "../../../../../../common/components/masked_inputs/money_masked_input";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";

/**
 * Header SaldoBancarioCadastro.
 * 
 */

type Props = {

  ddlCentroCusto: CentroCustoDropDown[];
  ddlSubconta: DropDown[];
  ddlFornecedor: DropDown[];
  ddlFuncionario: DropDown[];

  idsCentroCusto: number[];
  idsFornecedor: number[];
  idsFuncionario: number[];
  idsSubconta: number[];
  titulo?: string;
  nrConta?: number;
  dataDe?: Date;
  dataAte?: Date;
  tipo: number;
  valor?: number;

  onClearFilters: () => void;
  onStatusChange: (tipo: number) => void;
  handleIdCentroCustoChange: (v: number[]) => void;
  handleIdSubcontaChange: (v: number[]) => void;
  handleIdFornecedorChange: (v: number[]) => void;
  handleIdFuncionarioChange: (v: number[]) => void;

  handleTituloChange: (v: string | null) => void;
  handleNrContaChange: (v: string | null) => void;
  handleDataChange: (v: Date | null, x: Date | null) => void;
  handleValorChange: (v: string | null) => void;

};


export const Header = ({
  ddlCentroCusto,
  ddlSubconta,
  ddlFornecedor,
  ddlFuncionario,
  idsCentroCusto,
  idsFornecedor,
  idsFuncionario,
  idsSubconta,

  titulo,
  nrConta,
  dataDe,
  dataAte,
  tipo,
  valor,
  onClearFilters,
  onStatusChange,
  handleIdCentroCustoChange,
  handleIdSubcontaChange,
  handleIdFornecedorChange,
  handleIdFuncionarioChange,

  handleTituloChange,
  handleNrContaChange,
  handleDataChange,
  handleValorChange,


}: Props) => {


  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">



            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Centro de Custo'
                  value={ddlCentroCusto.filter(x => idsCentroCusto?.includes(x.id))}
                  options={ddlCentroCusto}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdCentroCustoChange(x?.map(y => y.id) ?? [])} />

              </div>

              <div className="w-full">
                <DefaultInput
                  name='titulo'
                  label='Titulo/Pedido'
                  readOnly={true}
                  value={titulo}
                  onChangeValue={handleTituloChange} />

              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-full">

                <DefaultDateRangePickerInput
                  label='Data pago'
                  dataDe={dataDe ?? null}
                  dataAte={dataAte ?? null}
                  onChange={async (start, end) => {
                    handleDataChange(start, end)
                  }} />

              </div>

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Subconta'
                  value={ddlSubconta.filter(x => idsSubconta?.includes(x.id))}
                  options={ddlSubconta}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdSubcontaChange(x?.map(y => y.id) ?? [])} />
              </div>

            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-[40%]">
                <DefaultMultiAutocomplete
                  label='Funcionário Folha'
                  value={ddlFuncionario.filter(x => idsFuncionario?.includes(x.id))}
                  options={ddlFuncionario}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdFuncionarioChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-[40%]">
                <DefaultMultiAutocomplete
                  label='Fornecedor'
                  value={ddlFornecedor.filter(x => idsFornecedor?.includes(x.id))}
                  options={ddlFornecedor}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdFornecedorChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-[20%]">
                <MoneyMaskedInput
                  name='Valor'
                  label='Valor'
                  onChange={handleValorChange}

                />
              </div>

            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-[30%]">
                <FormControl size="small" fullWidth>
                  <InputLabel id="modulo-dashboard"></InputLabel>
                  <Select
                    labelId="modulo-dashboard"
                    value={tipo ?? 4}
                    onChange={handleStatusChange}>
                    <MenuItem value={4}>Todos os movimentos</MenuItem>
                    <MenuItem value={0}>Crédito Inserido</MenuItem>
                    <MenuItem value={1}>Débito Inserido</MenuItem>
                    <MenuItem value={2}>Contas Pagar</MenuItem>
                    <MenuItem value={3}>Contas Receber</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <div className="w-[20%]">
                <MaskedInput
                  name={'nrConta'}
                  label={'Número da Conta'}
                  mask="00000"
                  maskPlaceholder="_____"
                  value={nrConta?.toString() ?? null}
                  onChange={handleNrContaChange}
                />
              </div>
            </div>


            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}